
import AdminNav from "./AdminNav";
import ClientNav from "./ClientNav";
import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from 'react-redux';
import { userLogout } from "../redux/authSlice";
import { Link, useNavigate } from "react-router-dom";

export default function Navbar() {

    const navigator = useNavigate();
    const dispatch = useDispatch();
    const authType = localStorage.getItem('authType');
    const { userDetail } = useSelector((state) => state.auth)
    useEffect(() => {

        if (userDetail) {
            const authType = localStorage.getItem('authType');


        } else {
            if (authType === 1) {
                navigator('/admin');
            } else {
                navigator('/login');
                const response = {
                    userDetail: null,
                    isLoggedIn: false
                };
                dispatch(userLogout(response));
            }
            return
        }
    }, [userDetail, navigator])
    return (
        <>
            {authType === '1' && userDetail && userDetail.user && userDetail.user[0] ?
                <AdminNav role={userDetail.user[0].role} />
                :
                <ClientNav />
            }
        </>
    );
}
